import { render, staticRenderFns } from "./calendar-check.vue?vue&type=template&id=5b48ed2e&"
import script from "./calendar-check.vue?vue&type=script&lang=js&"
export * from "./calendar-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b48ed2e')) {
      api.createRecord('5b48ed2e', component.options)
    } else {
      api.reload('5b48ed2e', component.options)
    }
    module.hot.accept("./calendar-check.vue?vue&type=template&id=5b48ed2e&", function () {
      api.rerender('5b48ed2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/calendar-check.vue"
export default component.exports